import { MAP_DEFAULT_INDEX, MAP_HOVERED_ICON_SIZE, MAP_NORMAL_ICON_SIZE, getPointSymbolLayerConfig } from "@l2r-front/l2r-map"
import { LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION } from "@l2r-front/l2r-networks"

import { NETWORK_ATTACHMENT, ROAD_ATTACHMENT, SECTION_ATTACHMENT } from "../constants/modules"

const NETWORK_ICON_SIZE = 0.9
export const NETWORK_ICON_INDEX = 5
const HOVERED_INDEX = 10

export function getDocumentItemLayerStyle(attachmentId, road, linearLocationStart, linearLocationEnd, hoveredAttachedObject) {
    const linearLocation = hoveredAttachedObject?.linear_location?.[0]
    const layerStyle = getPointSymbolLayerConfig({
        layout: {
            "symbol-sort-key": getConditionalStyle(hoveredAttachedObject, linearLocation, MAP_DEFAULT_INDEX, NETWORK_ICON_INDEX, HOVERED_INDEX),
            "icon-size": getConditionalStyle(hoveredAttachedObject, linearLocation, MAP_NORMAL_ICON_SIZE, NETWORK_ICON_SIZE, MAP_HOVERED_ICON_SIZE),
            "icon-image": ["get", "icon", ["properties"]],
        },
    })
    if (attachmentId) {
        layerStyle.filter.push(["==", ["get", "attached_object_uuid", ["properties"]], attachmentId])
    }
    if (linearLocationEnd && linearLocationStart && road) {
        layerStyle.filter.push([
            "all",
            [">=", ["get", "start", ["at", 0, ["get", "linearLocation"]]], parseFloat(linearLocationStart)],
            ["<=", ["get", "end", ["at", 0, ["get", "linearLocation"]]], parseFloat(linearLocationEnd)],
            ["==", ["get", "road", ["at", 0, ["get", "linearLocation"]]], road],
        ])
    }
    return layerStyle
}

function getConditionalStyle(hoveredAttachedObject, linearLocation, defaultValue, defaultNetworkValue, hoveredValue) {
    if (!hoveredAttachedObject) {
        return ["case",
            ["==", ["get", "attached_object_content_type"], NETWORK_ATTACHMENT],
            defaultNetworkValue, defaultValue]
    }
    return ([
        "case",
        hoveredAttachedObject.attached_object_uuid
            ? ["==", ["get", "attached_object_uuid"], hoveredAttachedObject.attached_object_uuid]
            : false,
        hoveredValue,
        hoveredAttachedObject.attached_object_content_type === NETWORK_ATTACHMENT
            ? [
                "all",
                ["==", ["get", "attached_object_content_type"], NETWORK_ATTACHMENT],
            ]
            : false,
        hoveredValue,
        hoveredAttachedObject.linear_location_type === LINEAR_LOCATION_ROAD
            ? [
                "all",
                ["==", ["get", "linear_location_type"], ROAD_ATTACHMENT],
                [
                    "==",
                    ["get", "road", ["at", 0, ["get", "linearLocation"]]],
                    linearLocation?.road,
                ],
            ]
            : false,
        hoveredValue,
        hoveredAttachedObject.linear_location_type === LINEAR_LOCATION_SECTION
            ? [
                "all",
                ["==", ["get", "linear_location_type"], SECTION_ATTACHMENT],
                [
                    "==",
                    ["get", "road", ["at", 0, ["get", "linearLocation"]]],
                    linearLocation?.road,
                ],
                [
                    "==",
                    ["get", "start", ["at", 0, ["get", "linearLocation"]]],
                    linearLocation?.start,
                ],
                [
                    "==",
                    ["get", "end", ["at", 0, ["get", "linearLocation"]]],
                    linearLocation?.end,
                ],
            ]
            : false,
        hoveredValue,
        ["case",
            ["==", ["get", "attached_object_content_type"], NETWORK_ATTACHMENT],
            defaultNetworkValue, defaultValue],
    ])
}
